<div *transloco="let t; read: 'http404'" class="root" [innerHTML]="t('text')">
</div>
